<template>
  <div style="height: 100%; ">
  <div class="grid-x align-middle">
    <div class="small-1 cell">
      <rare-back-icon
        class="backIcon"
        :tabIndex="19"
        @clicked="$router.go(-1)" />
    </div>
    <div class="cell small-10 text-center">
      <img src="@/assets/img/logos/rare-work-for-us.png" class="header-logo" alt="social mobility logo" />
    </div>
    <div class="small-1 cell">
      &nbsp;
    </div>

  </div>

  <div class="grid-x grid-padding-x align-middle contentContainer">
    <div class="cell small-12 contentPosition text-center">
      <h1>The best people are Rare.</h1>
    </div>
  </div>
  </div>
</template>

<script>

import RareBackIcon from 'rare-patternlab/icons/navigation/RareBackIcon';

export default {
  name: 'RareStoriesHeaderContents',
  components: {
    'rare-back-icon': RareBackIcon,
  },
};
</script>

<style scoped>

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: #ffffff;
    display: inline-block;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  @media only screen and (max-width: 640px)  {

    .backIcon {
      margin-left: 24px;
      margin-top: 24px;
    }

    .header-logo {
      height: 16px;
      margin-top: 24px;
    }


    h1 {
      font-size: 28px;
      line-height: 1.25;
      letter-spacing: 0.4px;
      margin-top: -120px;
    }
  }

  @media only screen and (min-width: 641px)  {

    .header-logo {
      height: 30px;
      margin-top: 40px;
    }

    .backIcon {
      margin-left: 24px;
    }

    h1 {
      font-size: 64px;
      line-height: 1.25;
      letter-spacing: 0.8px;
      margin-top: -120px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/workForRare/components/RareWorkForRareHeaderContents.vue